import { Loadable } from 'utils/components'
import { NEW_REQUEST_PATH as path } from 'constants/paths'

export default {
  path,
  component: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: 'New Request' */ './components/NewRequestPage'
      )
  })
}
